import { render, staticRenderFns } from "./ArticleFAQList.vue?vue&type=template&id=04bfa332&scoped=true&"
import script from "./ArticleFAQList.vue?vue&type=script&lang=js&"
export * from "./ArticleFAQList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFAQList.vue?vue&type=style&index=0&id=04bfa332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfa332",
  null
  
)

export default component.exports